export class Program {
	constructor(offset) {
		this.offset = offset || 0;
	}
	
	/**
	 * @param programs
	 * @param now { Date }
	 * @return { ?{nextOccurence: Date, program: Program} }
	 */
	static nextTime(programs, now) {
		const upcoming = programs.map(program => {
			return {nextOccurrence: program.nextOccurrence(now), program}
		}).filter(v => v.nextOccurrence !== null);
		
		if(0 === upcoming.length) {
			return null;
		}
		
		upcoming.sort((a,b) => a.nextOccurrence - b.nextOccurrence);
		return upcoming[0];
	}
	
	/**
	 * Returns a copy shifted to the specified offset.
	 * This can change the days, if the time crosses 00:00 when converted
	 * @param offset {int} Timezone offset in minutes. 0 = UTC. CEST = -120.
	 * @returns {Program}
	 */
	toOffset( offset ) {
		throw new Error('toOffset must be implemented ' + offset);
	}
	
	/**
	 * Returns a copy shifted to the time zone of the browser.
	 * @returns {Program}
	 */
	toLocal() {
		return this.toOffset( new Date().getTimezoneOffset() );
	}
	
	/**
	 * Returns a copy shifted to UTC. Shortcut for toOffset(0).
	 * @returns {Program}
	 */
	toUTC() {
		return this.toOffset( 0 );
	}
	
	/**
	 * Returns the next occurrence of this event, or `null` if there are no occurrences in the future
	 * @param now { Date } the timepoint to look relative from
	 * @return { ?Date }
	 */
	nextOccurrence(now) {
		throw new Error('minutesUntilNext must be implemented ' + now);
	}
}